import { render, staticRenderFns } from "./PageStopService.vue?vue&type=template&id=3199cd56&scoped=true&"
import script from "./PageStopService.vue?vue&type=script&lang=js&"
export * from "./PageStopService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3199cd56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3199cd56')) {
      api.createRecord('3199cd56', component.options)
    } else {
      api.reload('3199cd56', component.options)
    }
    module.hot.accept("./PageStopService.vue?vue&type=template&id=3199cd56&scoped=true&", function () {
      api.rerender('3199cd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/stopservice/PageStopService.vue"
export default component.exports